import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=72ac8fcc&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Notification.vue?vue&type=style&index=1&id=72ac8fcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac8fcc",
  null
  
)

export default component.exports